import { render, staticRenderFns } from "./SearchArea.vue?vue&type=template&id=218028da&"
import script from "./SearchArea.vue?vue&type=script&lang=js&"
export * from "./SearchArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports